/**
 * Authentication API Helpers
 * 
 * Functions for calling authentication endpoints.
 * Uses shared fetcher utility for consistent error handling.
 */

import { fetcher } from '../utils/fetcher';
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  PasswordReset,
  User
} from '../types/auth';

const AUTH_URL = '/api/v1/auth';

// T031: Auth API helpers

export const login = async (credential: string, password: string): Promise<LoginResponse> => {
  const data: LoginRequest = { credential, password };
  return await fetcher(`${AUTH_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
};

export const register = async (data: RegisterRequest): Promise<RegisterResponse> => {
  return await fetcher(`${AUTH_URL}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
};

export const logout = async (): Promise<void> => {
  const token = sessionStorage.getItem('token');
  if (token) {
    await fetcher(`${AUTH_URL}/logout`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` }
    });
  }
  sessionStorage.removeItem('token');
};

export const getCurrentUser = async (): Promise<User> => {
  return await fetcher(`${AUTH_URL}/me`);
};

export const requestPasswordReset = async (email: string): Promise<{ message: string }> => {
  const data = { email };
  return await fetcher(`${AUTH_URL}/password/forgot`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
};

export const resetPassword = async (reset_token: string, new_password: string): Promise<void> => {
  const data: PasswordReset = { reset_token, new_password };
  await fetcher(`${AUTH_URL}/password/reset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
};
